import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faStar,
  faBell,
  faDownload,
  faPlus,
  faInfoCircle,
  faChevronLeft,
  faChevronRight,
  faCopy,
  faClock,
} from '@fortawesome/free-solid-svg-icons';

import { FaBitcoin } from 'react-icons/fa';
import { FaLock } from 'react-icons/fa';

const StockDashboard = () => {
  
  const [selectedTimeframe, setSelectedTimeframe] = useState('1Y');
  const [activeTab, setActiveTab] = useState('Overview');

  const timeframes = ['1D', '1W', '1M', 'YTD', '1Y', 'Max'];
  const tabs = ['Overview', 'Portfolio', 'Dividends', 'Discussion'];

  const renderOverviewContent = () => (
    <div className="row g-3">
      {/* Price and Chart Section - Full Left Side */}
      <div className="col-lg-8">
        <div className='row g-3'>
       <div className='co-12'>
       <div className="portfolio-metric-card p-3 h-100">
          <div style={styles.sectionHeader}>
            <h3 style={styles.sectionTitle}>Price</h3>
            <div><span style={styles.sectionTitle} className='fw-bold'> <FaLock className='pe-2' style={{ fontSize: "18px", color: "#fff" }} />Add BenchMark</span></div>
            
          </div>
          <div style={styles.priceDisplay}>
            <div style={styles.mainPrice}>$ 119.04</div>           
          </div>
          <div className='d-flex justify-content-between'>
          <div style={styles.priceGain}>$28.79 (31.90%)</div>
          <div style={styles.timeframeButtons}>
              {timeframes.map((tf) => (
                <button
                  key={tf}
                  style={{
                    ...styles.timeframeButton,
                    ...(selectedTimeframe === tf ? styles.activeTimeframe : {})
                  }}
                  onClick={() => setSelectedTimeframe(tf)}
                >
                  {tf}
                </button>
              ))}
            </div>
          </div>
          <div style={styles.chartContainer}>
            <svg width="100%" height="200" style={styles.chart}>
              {/* Grid lines */}
              <line x1="0" y1="40" x2="100%" y2="40" stroke="#374151" strokeWidth="1" />
              <line x1="0" y1="80" x2="100%" y2="80" stroke="#374151" strokeWidth="1" />
              <line x1="0" y1="120" x2="100%" y2="120" stroke="#374151" strokeWidth="1" />
              <line x1="0" y1="160" x2="100%" y2="160" stroke="#374151" strokeWidth="1" />
              
              {/* Main price line */}
              <path
                d="M0 160 L20 140 L40 120 L60 100 L80 80 L100 60"
                stroke="#10B981"
                strokeWidth="3"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div style={styles.chartCredit}>CHART BY getquin</div>
          </div>
        </div>
       </div>
        <div className="col-12">
        <div className="portfolio-metric-card p-3">
        <div className='d-flex justify-content-between'>
        <h3 style={styles.sectionTitle}>Historical dividends and forecast</h3>
        <h3 style={styles.sectionTitle}>All Divided Data</h3>
        </div>
          <p className='mb-5 mt-4' style={styles.dividendNote}>The next dividend will be paid on 02.04.2025</p>
          <div className="mb-4" style={styles.dividendChart}>
            <div style={styles.chartControls}>
              <FontAwesomeIcon icon={faChevronLeft} style={styles.chartArrow} />
              <span style={styles.allDividendData}>All dividend data</span>
              <FontAwesomeIcon icon={faChevronRight} style={styles.chartArrow} />
            </div>
            <div style={styles.barChart}>
              {[
                { year: '2020', amount: '$0.016', change: '0%', height: 40 },
                { year: '2021', amount: '$0.016', change: '0%', height: 40 },
                { year: '2022', amount: '$0.016', change: '0%', height: 40 },
                { year: '2023', amount: '$0.016', change: '0%', height: 40 },
                { year: '2024', amount: '$0.034', change: '+112.5%', height: 80, positive: true },
                { year: '2025', amount: '$0.04', change: '+17.65%', height: 90, positive: true, forecast: true }
              ].map((item, index) => (
                <div key={index} style={styles.barContainer}>
                  <div 
                    style={{
                      ...styles.bar,
                      height: item.height,
                      backgroundColor: item.positive ? '#10B981' : '#3B82F6',
                      backgroundImage: item.forecast ? 'repeating-linear-gradient(45deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 4px)' : 'none'
                    }}
                  ></div>
                  <div style={styles.barLabels}>
                    <span style={styles.barAmount}>{item.amount}</span>
                    <span style={{
                      ...styles.barChange,
                      color: item.positive ? '#10B981' : '#9CA3AF'
                    }}>{item.change}</span>
                  </div>
                </div>
              ))}
            </div>
           
          </div>
        </div>
      </div>
        </div>
       
      </div>

      {/* Right Side Stack */}
      <div className="col-lg-4">
        <div className="d-flex flex-column h-100">
          {/* Financials Section */}
          <div className="portfolio-metric-card p-3 mb-3">
            <h2 className='mb-3' style={styles.sectionTitle}>Financials</h2>
            <div style={styles.financialsGrid}>
              <div style={styles.financialColumn}>
                <div>
                  <span className='text-secondary'>Market Cap</span>
                  <h6 className='text-white fw-bold'> $2.94T</h6>               
                </div>
                <div className='d-block'>
                <div style={styles.financialItem}>
                  <span>Free Float</span>
                  <FontAwesomeIcon className="ps-2" icon={faInfoCircle} style={styles.infoIcon} />
                </div>
                <h6 className='text-white fw-bold'>23.42B</h6>
                </div>
                <div className='d-block'>
                <div style={styles.financialItem}>
                  <span>Revenue (TTM)</span>
                  <FontAwesomeIcon className="ps-2" icon={faInfoCircle} style={styles.infoIcon} />
                </div>  
                <h6 className='text-white fw-bold'> $130.50B</h6>
                </div>
              </div>
              <div style={styles.financialColumn}>
              <div className='d-block'>
                <div style={styles.financialItem}>
                  <span>EPS (TTM) </span>
                  <FontAwesomeIcon className="ps-2" icon={faInfoCircle} style={styles.infoIcon} />
                </div>
                <h6 className='text-white fw-bold'>$2.94</h6>
                </div>
                <div className='d-block'>
                <div style={styles.financialItem}>
                  <span>P/E ratio (TTM) </span>
                  <FontAwesomeIcon className="ps-2" icon={faInfoCircle} style={styles.infoIcon} />
                </div>
                <h6 className='text-white fw-bold'> 41.0B</h6>
                </div>
                <div className='d-block'>
                <div style={styles.financialItem}>
                  <span>EBITDA (TTM) </span>
                  <FontAwesomeIcon className="ps-2" icon={faInfoCircle} style={styles.infoIcon} />
                </div>
                <h6 className='text-white fw-bold'>83B</h6>
                </div>
              </div>
            </div>
          </div>

          {/* Pricing Section */}
          <div className="portfolio-metric-card p-3 mb-3">
            <h4 className='mb-3' style={styles.sectionTitle}>Pricing</h4>
            <div className='text-secondary mb-4' style={styles.pricingItem}>
              <span>1D span</span>
              <div style={styles.rangeBar}>
                <span className='fw-bold text-white'>$118.77</span>               
                <span className='fw-bold text-white'>$120.75</span>                
              </div>
              <div style={styles.rangeSlider}>
                  <div style={styles.rangeFill}></div>
                  <div style={styles.rangeHandle}></div>
                </div>
            </div>
            <div className='text-secondary ' style={styles.pricingItem}>
              <span className='mb-0 pb-0'>52W span</span>
              <div style={styles.rangeBar}>
                <span className='fw-bold text-white'>$75.61</span>               
                <span className='fw-bold text-white'>$153.13</span>
              </div>
              <div style={styles.rangeSlider}>
                  <div style={styles.rangeFill}></div>
                  <div style={styles.rangeHandle}></div>
                </div>
            </div>
            <div>
              <div className="d-flex justify-content-start">
                <div className='me-5 text-secondary'> <span>Open</span></div>
                <div className='me-5 text-secondary'> <span>Close </span></div>
              </div>

              <div className="d-flex justify-content-start">
                <div className='me-5 fw-bold'> <span> $90.25</span></div>
                <div className='me-5 fw-bold'> <span> $190.25</span></div>
              </div>
            </div>
          </div>

          {/* Analyst Ratings Section */}
          <div className="portfolio-metric-card p-3">
            <h3 className='fw-bold mb-3' style={styles.sectionTitle}>Analyst Ratings</h3>
            <p style={styles.analystNote}>The price target is $174.19 and the stock is covered by 67 analysts.</p>
            <div style={styles.ratingBars}>
              <div style={styles.ratingItem}>
                <span>Buy</span>
                <div style={styles.ratingBar}>
                  <div style={{...styles.ratingFill, width: '92%', backgroundColor: '#10B981'}}></div>
                  <span style={styles.ratingCount}>62</span>
                </div>
              </div>
              <div style={styles.ratingItem}>
                <span>Hold</span>
                <div style={styles.ratingBar}>
                  <div style={{...styles.ratingFill, width: '7%', backgroundColor: '#6B7280'}}></div>
                  <span style={styles.ratingCount}>5</span>
                </div>
              </div>
              <div style={styles.ratingItem}>
                <span>Sell</span>
                <div style={styles.ratingBar}>
                  <div style={{...styles.ratingFill, width: '1%', backgroundColor: '#EF4444'}}></div>
                  <span style={styles.ratingCount}>0</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Historical Dividends Section - Full Width */}
      
    </div>
  );

  const renderPortfolioContent = () => (
    <div className="row g-3">
      <div className="col-12">
        <div className="portfolio-metric-card p-4">
          <h3 className="fw-bold mb-3">Portfolio Tab</h3>
          <p className="text-secondary">This is where you can add your portfolio-specific content.</p>
          <div className="row g-3 mt-3">
            <div className="col-md-6">
              <div className="p-3 border border-secondary rounded">
                <h5>Portfolio Holdings</h5>
                <p className="text-secondary">Add your portfolio holdings here</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="p-3 border border-secondary rounded">
                <h5>Portfolio Performance</h5>
                <p className="text-secondary">Add portfolio performance metrics here</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderDividendsContent = () => (
    <div className="row g-3">
      <div className="col-12">
        <div className="portfolio-metric-card p-4">
          <h3 className="fw-bold mb-3">Dividends Tab</h3>
          <p className="text-secondary">This is where you can add dividend-specific content.</p>
          <div className="row g-3 mt-3">
            <div className="col-md-6">
              <div className="p-3 border border-secondary rounded">
                <h5>Dividend History</h5>
                <p className="text-secondary">Add dividend history here</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="p-3 border border-secondary rounded">
                <h5>Dividend Yield</h5>
                <p className="text-secondary">Add dividend yield information here</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderDiscussionContent = () => (
    <div className="row g-3">
      <div className="col-12">
        <div className="portfolio-metric-card p-4">
          <h3 className="fw-bold mb-3">Discussion Tab</h3>
          <p className="text-secondary">This is where you can add discussion and community content.</p>
          <div className="row g-3 mt-3">
            <div className="col-md-6">
              <div className="p-3 border border-secondary rounded">
                <h5>Community Discussions</h5>
                <p className="text-secondary">Add community discussions here</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="p-3 border border-secondary rounded">
                <h5>News & Updates</h5>
                <p className="text-secondary">Add news and updates here</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Overview':
        return renderOverviewContent();
      case 'Portfolio':
        return renderPortfolioContent();
      case 'Dividends':
        return renderDividendsContent();
      case 'Discussion':
        return renderDiscussionContent();
      default:
        return renderOverviewContent();
    }
  };

  return (
    <div className="portfolio-card-modern rounded-4 shadow-sm p-4 mb-4"
      style={{
        background: "linear-gradient(90deg, #18181b 0%, #23272f85 100%)",
        border: "1px solid #23272f",
        color: "#fff",
      }}>
      {/* Top Header Bar */}
      <div className='d-block d-sm-block d-md-flex' style={styles.header}>
        <div style={styles.headerLeft}>
          <div style={styles.logoSection}>
            <div
              className="balance-icon d-flex align-items-center justify-content-center rounded-circle me-3"
              style={{
                background: "#f7931a",
                width: "30px",
                height: "30px",
                boxShadow: "0 2px 8px 0 rgba(247,147,26,0.12)",
              }}
            >
              <FaBitcoin style={{ fontSize: "15px", color: "#fff" }} />
            </div>
            <div style={styles.stockInfo}>
              <h1 style={styles.stockName}>Bitcoin</h1>
              <div style={styles.stockDetails}>
                <span className='bg-secondary'>Stock <FontAwesomeIcon icon={faCopy} style={styles.copyIcon} />          </span>
                <span>ISIN: US57066G1040 <FontAwesomeIcon icon={faCopy} style={styles.copyIcon} /></span>
                <span>Ticker: BTC <FontAwesomeIcon icon={faCopy} style={styles.copyIcon} /></span>
              </div>
            </div>
          </div>
          <div style={styles.priceSection}>
            <div style={styles.currentPrice}>$ 119.04</div>
            <div style={styles.priceChange}>
              <span style={styles.negativeChange}>$1.61 (1.34%)</span>
              <FontAwesomeIcon icon={faClock} style={styles.clockIcon} />
              <span style={styles.realTime}>Real-time price</span>
            </div>
          </div>
        </div>
        <div className='mb-3' style={styles.headerRight}>
          <div style={styles.icons}>
            <FontAwesomeIcon icon={faStar} style={styles.icon} />
            <FontAwesomeIcon icon={faBell} style={styles.icon} />
            <FontAwesomeIcon icon={faDownload} style={styles.icon} />
          </div>
          <div style={styles.transactionSection}>
            <FontAwesomeIcon icon={faPlus} style={styles.plusIcon} />
            <span style={styles.transaction}>Transaction</span>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div style={styles.navigation}>
        {tabs.map((tab) => (
          <span
            key={tab}
            style={{
              ...styles.tab,
              ...(activeTab === tab ? styles.activeTab : {})
            }}
            onClick={() => setActiveTab(tab)}
            className="cursor-pointe "
          >
            {tab}
          </span>
        ))}
      </div>

      {/* Tab Content */}
      {renderTabContent()}
    </div>
  );
};

const styles = {
  header: {
    justifyContent: 'space-between',
    alignItems: 'flex-start',  
  },

  
    headerLeft: {
    flex: 1
  },
  logoSection: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '15px'
  },
  logo: {
    width: '40px',
    height: '40px',
    backgroundColor: '#10B981',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    marginRight: '15px'
  },
  stockInfo: {
    flex: 1
  },
  stockName: {
    fontSize: '24px',
    fontWeight: 'bold',
    margin: '0 0 5px 0'
  },
  stockDetails: {
    fontSize: '12px',
    color: '#9CA3AF',
    display: 'flex',
    gap: '15px'
  },
  copyIcon: {
    fontSize: '10px',
    marginLeft: '5px',
    cursor: 'pointer'
  },
  priceSection: {
    marginBottom: '15px'
  },
  currentPrice: {
    fontSize: '32px',
    fontWeight: 'bold',
    marginBottom: '5px'
  },
  priceChange: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  negativeChange: {
    color: '#EF4444',
    fontSize: '14px'
  },
  clockIcon: {
    fontSize: '12px',
    color: '#9CA3AF'
  },
  realTime: {
    color: '#9CA3AF',
    fontSize: '12px'
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px'
  },
  icons: {
    display: 'flex',
    gap: '15px'
  },
  icon: {
    fontSize: '16px',
    color: '#9CA3AF',
    cursor: 'pointer'
  },
  transactionSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  plusIcon: {
    fontSize: '14px',
    color: '#FFFFFF'
  },
  transaction: {
    fontSize: '14px',
    color: '#FFFFFF'
  },
  navigation: {
    display: 'flex',
    gap: '20px',
    marginBottom: '20px',
    borderBottom: '1px solid #374151',
    paddingBottom: '10px',
    overflow: 'scroll'
  },
  tab: {
    color: '#9CA3AF',
    cursor: 'pointer',
    fontSize: '14px'
  },
  activeTab: {
    color: '#FFFFFF',
    fontWeight: '500',
    cursor: 'pointer',
    fontSize: '14px'
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px'
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: '600',
    margin: '0'
  },
  timeframeButtons: {
    display: 'flex',
    gap: '5px',
    overflow: 'scroll'
  },
  timeframeButton: {
    padding: '5px 10px',
    backgroundColor: 'transparent',
    border: '1px solid #374151',
    color: '#9CA3AF',
    borderRadius: '4px',
    fontSize: '12px',
    cursor: 'pointer'
  },
  activeTimeframe: {
    backgroundColor: '#3B82F6',
    borderColor: '#3B82F6',
    color: '#FFFFFF'
  },
    priceDisplay: {
    marginBottom: '20px'
  },
  mainPrice: {
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '5px'
  },
  priceGain: {
    color: '#10B981',
    fontSize: '16px'
  },
  chartContainer: {
    position: 'relative'
  },
  chart: {
    width: '100%'
  },
  chartCredit: {
    position: 'absolute',
    bottom: '10px',
    left: '10px',
    fontSize: '10px',
    color: '#9CA3AF'
  },
  financialsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '15px'
  },
  financialColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  financialItem: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    fontSize: '14px',
    color: '#9CA3AF'
  },
  infoIcon: {
    fontSize: '12px',
    color: '#9CA3AF'
  },
  pricingItem: {
    marginBottom: '15px',
    fontSize: '12px'
  },
  rangeBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    justifyContent: 'space-between',
    marginTop: '0px'
  },
  rangeSlider: {
    flex: 1,
    height: '4px',
    backgroundColor: '#374151',
    borderRadius: '2px',
    position: 'relative'
  },
  rangeFill: {
    height: '100%',
    width: '60%',
    backgroundColor: '#3B82F6',
    borderRadius: '2px'
  },
  rangeHandle: {
    position: 'absolute',
    top: '-2px',
    left: '60%',
    width: '8px',
    height: '8px',
    backgroundColor: '#FFFFFF',
    borderRadius: '50%'
  },
  pricingRow: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '14px',
    color: '#9CA3AF'
  },
  dividendNote: {
    color: '#9CA3AF',
    fontSize: '12px',
    marginBottom: '20px'
  },
  dividendChart: {
    position: 'relative'
  },
  chartControls: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px'
  },
  chartArrow: {
    fontSize: '14px',
    color: '#9CA3AF',
    cursor: 'pointer'
  },
  allDividendData: {
    color: '#9CA3AF',
    fontSize: '12px'
  },
  barChart: {
    display: 'flex',
    alignItems: 'end',
    gap: '20px',
    height: '120px',
    marginBottom: '20px',
    overflow:'scroll'
  },
  barContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1
  },
  bar: {
    width: '60px',
    backgroundColor: '#3B82F6',
    borderRadius: '2px 2px 0 0',
    marginBottom: '10px'
  },
  barLabels: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '10px'
  },
  barAmount: {
    color: '#FFFFFF'
  },
  barChange: {
    color: '#9CA3AF'
  },
  analystNote: {
    color: '#9CA3AF',
    fontSize: '14px',
    marginBottom: '20px'
  },
  ratingBars: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  ratingItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px'
  },
  ratingBar: {
    flex: 1,
    height: '10px',
    backgroundColor: '#374151',
    borderRadius: '10px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  ratingFill: {
    height: '100%',
    borderRadius: '10px'
  },
  ratingCount: {
    position: 'absolute',
    right: '10px',
    fontSize: '12px',
    color: '#FFFFFF'
  }
};

export default StockDashboard; 